import { Badge, Collapse, Group, ScrollArea, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconHistory } from '@tabler/icons-react';
import { formatTimeOfDay } from '../format';
import { AGENT_EVENT_LABELS } from './agent-status';

export type ActivityEvent = { id: string; eventType: string; occurredAt: string };

export function ActivityDrawer({
  activity,
  isOpen,
  onToggle,
}: {
  activity: ActivityEvent[];
  isOpen: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="border-t shrink-0" style={{ borderColor: 'var(--mantine-color-default-border)' }}>
      <UnstyledButton className="w-full px-4 py-2" onClick={onToggle}>
        <Group justify="space-between">
          <Group gap="xs">
            <IconHistory size={14} color="var(--mantine-color-dimmed)" />
            <Text size="xs" fw={600} c="dimmed" tt="uppercase" style={{ letterSpacing: '0.05em' }}>
              Recent Activity
            </Text>
            {activity.length > 0 && (
              <Badge size="xs" variant="light" color="gray">
                {activity.length}
              </Badge>
            )}
          </Group>
          {isOpen ? (
            <IconChevronDown size={14} color="var(--mantine-color-dimmed)" />
          ) : (
            <IconChevronUp size={14} color="var(--mantine-color-dimmed)" />
          )}
        </Group>
      </UnstyledButton>

      <Collapse in={isOpen}>
        <ScrollArea h={180} px="md" pb="sm">
          {activity.length === 0 ? (
            <Text size="sm" c="dimmed" ta="center" py="md">
              No recent activity
            </Text>
          ) : (
            <Stack gap={2}>
              {activity.map((event) => (
                <Group key={event.id} justify="space-between" py={4}>
                  <Text size="xs">{AGENT_EVENT_LABELS[event.eventType] ?? event.eventType}</Text>
                  <Text size="xs" c="dimmed" ff="monospace">
                    {formatTimeOfDay(event.occurredAt)}
                  </Text>
                </Group>
              ))}
            </Stack>
          )}
        </ScrollArea>
      </Collapse>
    </div>
  );
}
